/* Filter a practitioner roster by specialty.

   Progressive enhancement: every card is already in the HTML. The select is
   marked hidden in the template and only revealed once its options have been
   built from the cards actually present, so the control can never offer a
   specialty that yields nothing. */

function ismFilter() {
    document.querySelectorAll('[data-ism-filterable]').forEach((roster) => {
        const select = roster.querySelector('.ism-filter-select');
        const wrapper = roster.querySelector('.ism-filter');
        const count = roster.querySelector('.ism-filter-count');
        const empty = roster.querySelector('.ism-roster-empty');
        const cards = Array.from(roster.querySelectorAll('.ism-card'));
        if (!select || !cards.length) return;

        // Build the option list from the specialties the cards actually carry,
        // pairing each slug with the tag's real name.
        const labels = new Map();
        cards.forEach((card) => {
            const slugs = (card.dataset.specialties || '').trim().split(/\s+/).filter(Boolean);
            const names = (card.dataset.specialtyNames || '').split('|').map(s => s.trim());
            slugs.forEach((slug, i) => {
                if (slug === 'medecin' || slug.startsWith('equipe-')) return;
                if (!labels.has(slug)) labels.set(slug, names[i] || slug);
            });
        });
        if (labels.size < 2) return;

        Array.from(labels.entries())
            .sort((a, b) => a[1].localeCompare(b[1], 'fr'))
            .forEach(([slug, label]) => {
                const option = document.createElement('option');
                option.value = slug;
                option.textContent = label;
                select.appendChild(option);
            });

        wrapper.hidden = false;

        select.addEventListener('change', () => {
            const wanted = select.value;
            let shown = 0;

            cards.forEach((card) => {
                const slugs = (card.dataset.specialties || '').trim().split(/\s+/).filter(Boolean);
                const match = !wanted || slugs.includes(wanted);
                card.hidden = !match;
                if (match) shown += 1;
            });

            if (empty) empty.hidden = shown !== 0;
            if (count) {
                count.textContent = wanted
                    ? `${shown} praticien${shown > 1 ? 's' : ''}`
                    : '';
            }
        });
    });
}
